const initialState = {
  newOrganizationSapActivitiesForm: false,
  orgCntId: '',
  contactKey: '',
  contactKeyId: '',
  phone: '',
  fax: '',
};
export default initialState;
